<template>
  <el-dialog
    :title="type === 1 ? '新增站点信息' : '修改站点信息'"
    :visible.sync="visible"
    width="750px"
    @close="close"
  >
    <el-form :model="customerForm" ref="customerForm" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="11"
          ><el-form-item prop="siteId" label="站点ID" label-width="100px">
            <el-input
              v-model="customerForm.siteId"
              :disabled="type != 1"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="11"
          ><el-form-item prop="name" label="站点名称" label-width="100px">
            <el-input v-model="customerForm.name"></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11"
          ><el-form-item
            prop="installedCapacity"
            label="装机容量"
            label-width="100px"
          >
            <el-input
              placeholder="请输入内容"
              v-model="customerForm.installedCapacity"
            >
              <template slot="append">kWh</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11"
          ><el-form-item
            prop="installedPower"
            label="装机功率"
            label-width="100px"
          >
            <el-input
              placeholder="请输入内容"
              v-model="customerForm.installedPower"
            >
              <template slot="append">kW</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11"
          ><el-form-item
            prop="batteryType"
            label="电池类型"
            label-width="100px"
          >
            <el-select v-model="customerForm.batteryType" placeholder="请选择">
              <el-option
                v-for="item in batteryTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11"
          ><el-form-item prop="allotWay" label="投资方式" label-width="100px">
            <el-select v-model="customerForm.allotWay" placeholder="请选择">
              <el-option
                v-for="item in allotWayOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="11"
          ><el-form-item prop="rateId" label="费率标准" label-width="100px">
            <el-select v-model="customerForm.rateId" placeholder="请选择">
              <el-option
                v-for="item in rateOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> </el-form-item
        ></el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="11"
          ><el-form-item prop="address" label="项目地址" label-width="100px">
            <el-cascader
              size="large"
              :options="options"
              v-model="customerForm.selectedOptions"
              @change="handleChange"
            >
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="11"
          ><el-form-item
            prop="dailyChargeTimes"
            label="日充放次数"
            label-width="100px"
          >
            <el-select
              v-model="customerForm.dailyChargeTimes"
              placeholder="请选择"
            >
              <el-option
                v-for="item in chargeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11"
          ><el-form-item
            prop="service"
            label="系统质保开始"
            label-width="100px"
          >
            <el-date-picker
              v-model="customerForm.sysServiceBeginTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11"
          ><el-form-item
            prop="service"
            label="系统质保结束"
            label-width="100px"
          >
            <el-date-picker
              v-model="customerForm.sysServiceEndTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11"
          ><el-form-item
            prop="service"
            label="电池质保开始"
            label-width="100px"
          >
            <el-date-picker
              v-model="customerForm.startTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11"
          ><el-form-item
            prop="service"
            label="电池质保结束"
            label-width="100px"
          >
            <el-date-picker
              v-model="customerForm.endTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="11"
          ><el-form-item prop="investment" label="投资额" label-width="100px">
            <el-input
              placeholder="请输入内容"
              v-model="customerForm.investment"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11"
          ><el-form-item
            prop="decayRate"
            label="环境利用率"
            label-width="100px"
          >
            <el-input
              placeholder="请输入内容"
              v-model="customerForm.envUseRatio"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        :gutter="20"
        v-for="(item, j) in customerForm.jsonRatioData"
        :key="j"
      >
        <el-col :span="11"
          ><el-form-item
            :prop="'jsonRatioData.' + j + '.customerId'"
            :label="'客户'"
            label-width="100px"
            :rules="rules.customerId"
          >
            <!-- <el-input v-model="customerForm.customerId"></el-input> -->
            <el-select v-model="item.customerId" placeholder="请选择">
              <el-option
                v-for="item in customerOptions"
                :key="item.id"
                :label="item.companyName"
                :value="item.id"
              >
              </el-option>
            </el-select> </el-form-item
        ></el-col>
        <el-col :span="11"
          ><el-form-item
            :prop="'jsonRatioData.' + j + '.ratio'"
            label="投资比例"
            label-width="100px"
            :rules="rules.ratio"
          >
            <el-input v-model="item.ratio"></el-input> </el-form-item
        ></el-col>
        <el-col :span="2">
          <i
            v-if="j === 0 && customerForm.allotWay > 0"
            @click="addDataList()"
            style="font-size: 20px; color: #25c4fe; margin: 8px 0 0 10px"
            class="el-icon-circle-plus"
          ></i>
          <i
            v-if="j > 0"
            @click="deleteDataList(j)"
            style="font-size: 20px; color: #25c4fe; margin: 8px 0 0 10px"
            class="el-icon-remove"
          ></i>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer" v-if="type != 3">
      <!-- <el-button @click="dialogVisible = false" type="info" size="mini"
            >返回</el-button
            > -->
      <el-button
        class="btn-blue"
        type="primary"
        style="color: #000"
        @click="onSubmit('customerForm')"
        >{{
          type === 1 ? $t("addDevice.add") : $t("addDevice.edit")
        }}</el-button
      >
      <!-- <el-button type="primary" size="mini" v-else>修改</el-button> -->
    </span>
  </el-dialog>
</template>
<script>
import { siteAdd, siteEdit } from "@/api/siteList.js";
import { rateQuery } from "@/api/rateList";
import { customerQuery } from "@/api/customer";
import { deepClone } from "@/utils/deepClone";
import { provinceAndCityData, CodeToText } from "element-china-area-data";
import i18n from "@/lang";
export default {
  data() {
    return {
      visible: false,
      type: 1, //1新增 2编辑
      customerForm: {
        jsonRatioData: [
          {
            customerId: "",
            ratio: 0,
          },
        ],
        address: "",
        service: ["", ""],
        startTime: "",
        endTime: "",
        selectedOptions: [],
        soc: 0,
        totalRunDay: 0,
        totalEarnings: 0,
        investment: 0,
        decayRate: 0,
        envUseRatio: 0,
      },
      rules: {
        name: [
          {
            required: true,
            message: "不为空",
            trigger: ["blur"],
          },
        ],
        siteId: [
          {
            required: true,
            message: "不为空",
            trigger: ["blur"],
          },
        ],
        installedPower: [
          {
            required: true,
            message: "不为空",
            trigger: ["blur"],
          },
        ],
        installedCapacity: [
          {
            required: true,
            message: "不为空",
            trigger: ["blur"],
          },
        ],
        investment: [
          {
            required: true,
            message: "不为空",
            trigger: ["blur"],
          },
        ],
        envUseRatio: [
          {
            required: true,
            message: "不为空",
            trigger: ["blur"],
          },
        ],
        // decayRate: [
        //   {
        //     required: true,
        //     message: "不为空",
        //     trigger: ["change"],
        //   },
        // ],
        allotWay: [
          {
            required: true,
            message: "不为空",
            trigger: ["change"],
          },
        ],
        rateId: [
          {
            required: true,
            message: "不为空",
            trigger: ["change"],
          },
        ],
        batteryType: [
          {
            required: true,
            message: "不为空",
            trigger: ["change"],
          },
        ],
        dailyChargeTimes: [
          {
            required: true,
            message: "不为空",
            trigger: ["change"],
          },
        ],
        address: [
          {
            required: true,
            message: "不为空",
            trigger: ["change"],
          },
        ],
        customerId: [
          {
            required: true,
            message: "不为空",
            // trigger: ["change"],
          },
        ],
        ratio: [
          {
            required: true,
            message: "不为空",
            // trigger: ["blur", "change"],
          },
        ],
      },
      options: provinceAndCityData,
      rateOptions: [],
      customerOptions: [],
      allotWayOptions: [
        {
          id: 1,
          name: "电价折扣",
        },
        {
          id: 2,
          name: "投资分红",
        },
      ],
      chargeOptions: [
        {
          id: 1,
          name: "一充一放",
        },
        {
          id: 2,
          name: "两充两放",
        },
        {
          id: 3,
          name: "三充三放",
        },
      ],
      envOptions: [
        {
          label: "单休",
          value: 82.74,
        },
        {
          label: "双休",
          value: 68.49,
        },
        {
          label: "法定节假日",
          value: 96.99,
        },
        {
          label: "全年无休",
          value: 100,
        },
      ],
      batteryTypeOptions: [
        {
          label: "梯次电池",
          value: 0,
        },
        {
          label: "新电池",
          value: 1,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handleChange() {
      var loc = "";
      for (let i = 0; i < this.customerForm.selectedOptions.length; i++) {
        loc += CodeToText[this.customerForm.selectedOptions[i]];
        // let x = CodeToText[this.customerForm.selectedOptions[i]];
        // console.log(x);
        if (i != this.customerForm.selectedOptions.length - 1) {
          loc += ",";
        }
      }
      var reg1 = new RegExp("省", "g"); // 加'g'，删除字符串里所有的"a"
      var reg2 = new RegExp("市", "g");
      var a1 = loc.replace(reg1, "");
      var a2 = a1.replace(reg2, "");
      // console.log(a2);
      this.customerForm.address = a2;
    },
    getRate() {
      rateQuery()
        .then((res) => {
          console.log(res.data.data.list);
          this.rateOptions = res.data.data.list;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCustomer() {
      customerQuery()
        .then((res) => {
          console.log(res.data.data.list);
          this.customerOptions = res.data.data.list;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addDataList() {
      let info = {
        customerId: 0,
        ratio: 0,
      };
      this.customerForm.jsonRatioData.push(info);
    },
    deleteDataList(index) {
      this.customerForm.jsonRatioData.splice(index, 1);
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(JSON.stringify(this.customerForm.jsonRatioData));
          let obj = {
            siteId: this.customerForm.siteId,
            name: this.customerForm.name,
            rateId: this.customerForm.rateId,
            allotWay: this.customerForm.allotWay,
            jsonRatioData: JSON.stringify(this.customerForm.jsonRatioData),
            address: this.customerForm.address,
            serviceBeginTime: this.customerForm.startTime,
            serviceEndTime: this.customerForm.endTime,
            sysServiceBeginTime: this.customerForm.sysServiceBeginTime,
            sysServiceEndTime: this.customerForm.sysServiceEndTime,
            dailyChargeTimes: this.customerForm.dailyChargeTimes,
            installedPower: this.customerForm.installedPower,
            installedCapacity: this.customerForm.installedCapacity,
            totalEarnings: this.customerForm.totalEarnings,
            totalRunDay: this.customerForm.totalRunDay,
            soc: this.customerForm.soc,
            online: this.customerForm.online,
            status: this.customerForm.status,
            totalChargeNum: this.customerForm.totalChargeNum,
            totalDischargeNum: this.customerForm.totalDischargeNum,
            investment: this.customerForm.investment,
            decayRate: this.customerForm.decayRate / 100,
            envUseRatio: this.customerForm.envUseRatio / 100,
            batteryType: this.customerForm.batteryType,
          };
          console.log(obj);
          if (this.type === 1) {
            this.addInfo(obj);
          } else if (this.type === 2) {
            this.editInfo(obj);
          }
        }
      });
    },
    addInfo(obj) {
      console.log("add", obj);
      obj.totalEarnings = 0;
      obj.totalRunDay = 0;
      obj.soc = 0;
      obj.online = 0;
      obj.status = 0;
      obj.totalChargeNum = 0;
      obj.totalDischargeNum = 0;
      siteAdd(obj).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: i18n.t("prompt.operateSuccessfully"),
          });
          this.$emit("refresh");
          this.visible = false;
        } else {
          this.$message({
            type: "error",
            message: i18n.t("prompt.operationFailure") + res.data.message,
          });
        }
      });
    },
    editInfo(obj) {
      obj.id = this.customerForm.id;
      console.log("edit", obj);

      siteEdit(obj).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: i18n.t("prompt.operateSuccessfully"),
          });
          this.$emit("refresh");
          this.visible = false;
        } else {
          this.$message({
            type: "error",
            message: i18n.t("prompt.operationFailure") + res.data.message,
          });
        }
      });
    },
    open(type, row) {
      console.log(typeof type, type, row);
      this.getRate();
      this.getCustomer();
      this.visible = true;
      this.type = type;
      this.customerForm = {
        jsonRatioData: [
          {
            customerId: "",
            ratio: 0,
          },
        ],
      };
      if (type === 1) {
        this.viewDisable = false;
      } else if (this.type === 2) {
        this.customerForm = deepClone(row);
        this.customerForm.jsonRatioData = JSON.parse(row.jsonRatioData);
        // console.log(row.serviceBeginTime.substr(0, 10));
        this.$set(
          this.customerForm,
          "startTime",
          row.serviceBeginTime.substr(0, 10)
        );
        this.$set(
          this.customerForm,
          "endTime",
          row.serviceEndTime.substr(0, 10)
        );
        this.$set(
          this.customerForm,
          "sysServiceBeginTime",
          row.sysServiceBeginTime.substr(0, 10)
        );
        this.$set(
          this.customerForm,
          "sysServiceEndTime",
          row.sysServiceEndTime.substr(0, 10)
        );
        this.customerForm.decayRate = this.customerForm.decayRate * 100;
        this.customerForm.envUseRatio = this.customerForm.envUseRatio * 100;
        console.log(
          this.customerForm.decayRate,
          this.customerForm.decayRate * 100
        );
        // this.customerForm.startTime = row.serviceBeginTime.substr(0, 10);
        // this.customerForm.endTime = row.serviceEndTime.substr(0, 10);
        // if()
        console.log(row, this.customerForm, "hhhhhh222");
      } else if (type === 3) {
        this.customerForm = deepClone(row);
        this.customerForm.jsonRatioData = JSON.parse(
          this.customerForm.jsonRatioData
        );
        this.$set(
          this.customerForm,
          "startTime",
          row.serviceBeginTime.substr(0, 10)
        );
        this.$set(
          this.customerForm,
          "endTime",
          row.serviceEndTime.substr(0, 10)
        );
        this.$set(
          this.customerForm,
          "sysServiceBeginTime",
          row.sysServiceBeginTime.substr(0, 10)
        );
        this.$set(
          this.customerForm,
          "sysServiceEndTime",
          row.sysServiceEndTime.substr(0, 10)
        );
      }
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
/deep/ .el-input{
  width 90% !important
}
/deep/ .el-select{
  width 90% !important
}
/deep/ .el-select .el-input{
  width 100% !important
}
/deep/ .el-range-editor.el-input__inner{
  width 102% !important
}
</style>
